import { store } from '../../helpers/store';
import { flagService } from '../flagService';

/**
 * @docs https://docs.smartlook.com/docs/web
 */

const SL_ID = process.env.REACT_APP_SMARTLOOK_ID as string;

let _disabled_ = false;
let _initialized_: boolean;

//#region TEMPORARY until we remove FF
let _ready_ = false;
let _isSmartlookOn_ = false;
// listen to redux state change and wait until feature enabled

store.subscribe(() => {
  const state = store.getState();
  const isSmartlookOn = flagService.isFlagOn(state, 'smartlookImplementation');
  if (isSmartlookOn === true) {
    _isSmartlookOn_ = true;
    if (_ready_) {
      initialize(_disabled_);
    }
  }
});
//#endregion

//#region TYPES
// copy from https://github.com/smartlook/smartlook-client/blob/master/dist/index.d.ts
type SmartlookClient = {
  init: (key: string) => boolean;
  identify: (
    userId: string | number,
    props: {
      [key: string]: string | number | boolean;
    }
  ) => boolean;
  anonymize: () => boolean;
  track: (
    eventName: string,
    props: {
      [key: string]: string | number | boolean;
    }
  ) => boolean;
  disable: () => boolean;
  record: (params: {
    forms?: boolean;
    ips?: boolean;
    numbers?: boolean;
    emails?: boolean;
    api?: boolean;
  }) => boolean;
  getData: (callback: () => void) => boolean;
  restart: () => boolean;
  pause: () => boolean;
  resume: () => boolean;
  error: (error: string | Error) => boolean;
  navigation: (locationOrPath: string) => boolean;
  properties: (properties: { [key: string]: string | number | boolean }) => boolean;
  initialized: () => boolean;
};

// there's no types for web so we creating our own
function smartlookInterface(action: 'init', apiKey: string);
function smartlookInterface(
  action: 'identify',
  userId: string | number,
  props: {
    [key: string]: string | number | boolean;
  }
);
function smartlookInterface(action: 'anonymize');
function smartlookInterface(
  action: 'track',
  eventName: string,
  props: {
    [key: string]: string | number | boolean;
  }
);

function smartlookInterface(action: 'disable');
function smartlookInterface(action: 'getData', callback: () => void);
function smartlookInterface(action: 'record', params: { forms?: boolean, ips?: boolean, numbers?: boolean, emails?: boolean, api?: boolean });
function smartlookInterface(action: 'restart');
function smartlookInterface(action: 'pause');
function smartlookInterface(action: 'resume');
function smartlookInterface(action: 'error', error: string | Error);
function smartlookInterface(action: 'navigation', locationOrPath: string);
function smartlookInterface(
  action: 'properties',
  properties: { [key: string]: string | number | boolean }
);
function smartlookInterface(action) {}
export type SmartlookWeb = typeof smartlookInterface;
declare global {
  interface Window {
    smartlook: SmartlookWeb;
  }
}
//#endregion

// only run when performance = true

function initialize(disable = false) {
  if (!SL_ID) {
    if (process.env.NODE_ENV === 'development') {
      console.warn(
        `[SL] to enable Smartlook in dev time add 'REACT_APP_SMARTLOOK_ID='{dev_token_here}'' to '.env.development.local' file`
      );
    }
    return;
  }

  _disabled_ = disable;

  if (_disabled_ && _initialized_) {
    window.smartlook('disable');
    return;
  }
  //#region TEMPORARY until we remove FF
  _ready_ = true;

  if (!_isSmartlookOn_) {
    return;
  }

  if (_initialized_) {
    return;
  }

  _initialized_ = false;

  /* eslint-disable */
  function initialize(window: Window) {
    window.smartlook ||
      (function (d) {
        let o = (window.smartlook = function () {
            // @ts-ignore
            o.api.push(arguments);
          }),
          h = d.getElementsByTagName('head')[0];
        let c = d.createElement('script');
        // @ts-ignore
        o.api = new Array();
        c.async = true;
        c.src = 'https://rec.smartlook.com/recorder.js';
        h.appendChild(c);
      })(document);
    window.smartlook('init', SL_ID);
    _initialized_ = true;
    if (_disabled_) {
      window.smartlook('disable');
    }
  }
  /* eslint-disable */
  initialize(window);
  //   }
}

/**
 * @docs https://docs.smartlook.com/docs/web/identify-visitor?platform=web
 */
function identify(...args: Parameters<SmartlookClient['identify']>) {
  window.smartlook('identify', ...args);
}
/**
 * @docs https://docs.smartlook.com/docs/web/identify-visitor?platform=web
 */
function anonymize() {
  window.smartlook('anonymize');
}
function track(...args: Parameters<SmartlookClient['track']>) {
  window.smartlook('track', ...args);
}

function disable() {
  window.smartlook('disable');
}

function navigation(...args: Parameters<SmartlookClient['navigation']>) {
  window.smartlook('navigation', ...args);
}

export const smartlook = {
  initialize,
  identify,
  anonymize,
  track,
  disable,
  navigation,
};
